/** @format */

import { Box, Container } from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
	SlideShowContainer,
	SlideContent,
	SlideTitle,
	SlideDescription,
	SlideNumber,
	DotsContainer,
	Dot,
	CTAButton,
	SlideWrapper,
	OverlayGradient,
} from "./styles";
import { useNavigate } from "react-router-dom";
import {
	AccountBalance,
	Groups,
	Autorenew,
	TrendingUp,
} from "@mui/icons-material";

const MemberSection = () => {
	const { t } = useTranslation("home");
	const navigate = useNavigate();
	const [currentSlide, setCurrentSlide] = useState(0);

	const slides = [
		{
			icon: <Groups sx={{ fontSize: 60 }} />,
			title: t("memberSection.title"),
			description: t("memberSection.description"),
			color: "#1ec195",
		},
		{
			icon: <Autorenew sx={{ fontSize: 60 }} />,
			title: t("memberSection.feature1"),
			description: t("memberSection.feature1Desc"),
			color: "#040d45",
		},
		{
			icon: <AccountBalance sx={{ fontSize: 60 }} />,
			title: t("memberSection.feature2"),
			description: t("memberSection.feature2Desc"),
			color: "#1ec195",
		},
		{
			icon: <TrendingUp sx={{ fontSize: 60 }} />,
			title: t("memberSection.feature3"),
			description: t("memberSection.feature3Desc"),
			color: "#040d45",
		},
	];

	useEffect(() => {
		const timer = setInterval(() => {
			setCurrentSlide((prev) => (prev + 1) % slides.length);
		}, 5000);
		return () => clearInterval(timer);
	}, [slides.length]);

	const handleDotClick = (index: number) => {
		setCurrentSlide(index);
	};

	const handleJoinClick = () => {
		navigate("/circle/sign-up");
	};

	return (
		<Container maxWidth="xl" sx={{ my: 8 }}>
			<SlideShowContainer>
				<OverlayGradient />
				{slides.map((slide, index) => (
					<SlideWrapper
						key={index}
						isActive={index === currentSlide}
						slideColor={slide.color}>
						<Box sx={{ color: "white", mb: 3, opacity: 0.9 }}>{slide.icon}</Box>
						<SlideNumber>{`0${index + 1}`}</SlideNumber>
						<SlideContent>
							<SlideTitle data-aos="fade-up">{slide.title}</SlideTitle>
							<SlideDescription data-aos="fade-up" data-aos-delay="100">
								{slide.description}
							</SlideDescription>
							<CTAButton
								variant="contained"
								onClick={handleJoinClick}
								data-aos="fade-up"
								data-aos-delay="200">
								{t("memberSection.cta")}
							</CTAButton>
						</SlideContent>
					</SlideWrapper>
				))}

				<DotsContainer>
					{slides.map((_, index) => (
						<Dot
							key={index}
							isActive={index === currentSlide}
							onClick={() => handleDotClick(index)}
						/>
					))}
				</DotsContainer>
			</SlideShowContainer>
		</Container>
	);
};

export default MemberSection;
